"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconDetails = function SvgIconDetails(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "details icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Details Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.791 33.215a7.324 7.324 0 018.592-8.594c2.834.536 5.134 2.791 5.728 5.613a7.283 7.283 0 01-1.053 5.587l3.621 3.622c.245.268.401.624.401 1.018 0 .811-.648 1.468-1.448 1.468-.396 0-.755-.16-1.017-.42h-.003l-3.62-3.62a7.283 7.283 0 01-5.587 1.052c-2.823-.594-5.078-2.893-5.614-5.726zM31.02 5a5.657 5.657 0 015.65 5.65v8.688a1.412 1.412 0 11-2.825 0V10.65a2.828 2.828 0 00-2.825-2.825H13.65a2.828 2.828 0 00-2.825 2.825v24.863a2.828 2.828 0 002.825 2.825h4.724a1.412 1.412 0 110 2.825H13.65A5.657 5.657 0 018 35.514V10.65A5.657 5.657 0 0113.65 5h17.37zm7.175 27.988a4.4 4.4 0 00-5.419-5.419 4.328 4.328 0 00-3.037 3.036 4.4 4.4 0 005.42 5.42 4.328 4.328 0 003.036-3.037zm-14.301-8.211a1.412 1.412 0 110 2.826h-8.837a1.413 1.413 0 010-2.826h8.837zm5.713-5.651a1.413 1.413 0 010 2.826h-14.55a1.413 1.413 0 110-2.826h14.55zm0-5.65a1.413 1.413 0 110 2.825h-14.55a1.412 1.412 0 110-2.825h14.55z"
  }));
};

var _default = SvgIconDetails;
exports.default = _default;